import { endlessPaginate } from "endless_pagination/endless-pagination-module.js";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	// paginazione news
	endlessPaginate();

	// preview immagini nella scheda
	const gallery_preview = document.querySelector("#_gallery-preview");
	if (gallery_preview) {
		import("../../common/image_gallery.js").then((module) => {
			const MovieFreeGLightbox = module.MovieFreeGLightbox;
			const images = [];
			for (const el of document.querySelectorAll("._gallery_img")) {
				images.push({ href: el.dataset.gallerySrc });
			}
			new MovieFreeGLightbox({
				elements: images,
				selector: "#_gallery-preview ._gallery_img",
			});
		});
	}

	// lightbox immagini episodio
	for (const episode of document.querySelectorAll("._episode_images")) {
		episode.addEventListener("click", (event) => {
			event.preventDefault();
			const target = event.currentTarget;
			import("../../common/image_gallery.js").then((module) => {
				const MovieGLightbox = module.MovieGLightbox;
				new MovieGLightbox({
					url: `/misc/immagini/${target.dataset.ct}/${target.dataset.id}/`,
				});
			});
		});
	}

	// lightbox cast episodio
	for (const episode of document.querySelectorAll("._episode_cast")) {
		episode.addEventListener("click", (event) => {
			event.preventDefault();
			const target = event.currentTarget;
			fetch(`/misc/cast/${target.dataset.ct}/${target.dataset.id}/`, {
				headers: {
					"X-Requested-With": "XMLHttpRequest",
				},
				cache: "no-cache",
			})
				.then((response) => {
					if (response.status === 200) {
						return response.text();
					}
					console.warn(" --- Error: ", response.statusText);
				})
				.then((data) => {
					if (data) {
						import("basiclightbox").then((basicLightbox) => {
							const castLightbox = basicLightbox.create(data);
							castLightbox.show();
						});
					}
				})
				.catch((error) => {
					console.warn(error);
				});
		});
	}

	// Aggiornamento data articoli
	if (document.querySelector("#news")) {
		import("../../common/pubdate.js");
	}
});
